// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"47829ebc","455":"9cd8ed98","977":"f9873932"}[chunkId] + ".chunk.js";
};